import styled from 'styled-components';
import { gridSizes, media, weights, zIndexses } from 'utils/style';

import Modal from 'components/layout/Modal/component';

export default styled(Modal)`
  body: {
    overflow: hidden;
  }

  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding: 1rem;
  background-color: rgba(0, 0, 0, 0.7);
  zindex: 9999;
  opacity: 1;
  animation: show 0.5s ease;
  z-index: ${zIndexses.modalContainer};

  overflow-y: auto;

  @keyframes show {
    0%: {
      display: none;
      opacity: 0;
    }

    1%: {
      display: flex;
      opacity: 0;
    }

    100%: {
      opacity: 1;
    }
  }

  ${media.lessThan('extraSmall')`
        padding: 0;
      `};

  .modal {
    margin: auto;

    position: relative;
    display: flex;
    flex-direction: column;

    z-index: ${zIndexses.modal};

    &.S {
      width: 344px;
    }

    &.M {
      width: 544px;
    }

    &.L {
      width: 840px;
    }

    &.XL {
      width: 1140px;
    }

    max-width: 90%;

    ${media.lessThan('extraSmall')`
            margin: 0;
            padding: 0;
        `};

    .content {
      box-shadow: rgba(0, 0, 0, 0.5) 0px 1px ${gridSizes('S')} 0px;
      display: block;
      background: rgb(255, 255, 255);
      border-radius: 1.6rem;
      margin: 100px 0;
      padding-bottom: 1.6rem;

      &.sticky {
        max-height: 80vh;
        overflow: scroll;
        ${media.lessThan('extraSmall')`
            max-height: 100vh;
          `};
      }

      ${media.lessThan('extraSmall')`
                margin: 0;
                width: 100vw;
                border-radius: 0;
                background: var(--white-caniche);

                &.flex{
                  min-height: 100vh;
                  display: flex;
                  flex-direction: column;
                  flex: 1;
                }

        `};
    }
  }

  .close-container {
    padding: ${gridSizes('M')} ${gridSizes('L')};
    justify-content: flex-end;
    display: flex;
    align-items: flex-end;
    padding-bottom: 0px;
    justify-content: space-between;

    .title {
      font-family: Roboto;
      font-size: ${gridSizes('M')};
      text-align: left;
      color: var(--grey900);
      font-weight: ${weights('medium')};
      margin: 0;

      ${media.lessThan('extraSmall')`
          font-weight: ${weights('regular')};
        `};
    }

    .close {
      background: none;
      color: inherit;
      border: none;
      font: inherit;
      cursor: pointer;
      outline: inherit;
    }

    ${media.lessThan('extraSmall')`
      margin: inherit;
      justify-content: center;
      align-items: center;
      padding: ${gridSizes('M')};
      flex-direction: row-reverse;
      background: #fff;
      border-bottom: solid 1px var(--grey-mouse);
      justify-content: flex-end;
      .close{
        margin-right: ${gridSizes('M')};
      }
    `};
  }

  @media print {
    display: block !important;
    position: inherit !important;
    padding: 0 !important;
    overflow: visible !important;

    .modal {
      margin: 0 !important;
      width: 100vw !important;
      max-width: none !important;

      .content {
        box-shadow: initial !important;
        border-radius: inherit !important;
        padding: initial !important;
        margin: initial !important;
      }

      button {
        display: none !important;
      }
    }

    .header {
      display: none !important;
    }

    .main {
      display: none !important;
    }
  }
`;
